<template>
  <div>
    <v-snackbar v-model="show" :vertical="false" timeout="-1" light style="opacity: 0.9">
      <div class="text-body-2">
        <span
          class="mr-1"
          v-t="
            `We use cookies on this website. By continuing to use it, you agree to the conditions for their use and the privacy policy.`
          "
        />
        <router-link class="link" :to="{ name: 'privacy' }">
          <span v-t="`Read more`" />
        </router-link>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn color="primary darken-2" text v-bind="attrs" @click="onAccept">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: !localStorage.getItem("cookieNoticeAccepted"),
    };
  },
  methods: {
    onAccept() {
      localStorage.setItem("cookieNoticeAccepted", "1");
      this.show = false;
    },
  },
};
</script>